"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// TODO(2fd): looks to big, refactor?
const react_1 = require("react");
const txUtils_1 = require("decentraland-dapps/dist/modules/transaction/txUtils");
const utils_1 = require("decentraland-dapps/dist/modules/transaction/utils");
const Time_1 = __importDefault(require("../utils/date/Time"));
const rollbar_1 = __importDefault(require("../utils/development/rollbar"));
const segment_1 = __importDefault(require("../utils/development/segment"));
const storage_1 = require("../utils/tx/storage");
const initialState = [];
function useTransaction(address, chainId) {
    const [transactions, setTransactions] = (0, react_1.useState)(initialState);
    // re-store tranasctions
    (0, react_1.useEffect)(() => {
        if (address && chainId) {
            setTransactions((0, storage_1.restoreTransactions)(address, chainId));
        }
    }, [address, chainId]);
    // track transactions
    (0, react_1.useEffect)(() => {
        let closed = false;
        let timer = null;
        function updateTransactions() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!address || !chainId) {
                    return;
                }
                let txs = transactions || [];
                const updatedTransactions = [];
                for (const tx of txs) {
                    if ((0, utils_1.isPending)(tx.status)) {
                        const updatedTransaction = yield (0, txUtils_1.getTransaction)(address, tx.chainId, tx.hash);
                        if (updatedTransaction) {
                            const hasChanges = Object.keys(updatedTransaction).some((key) => tx[key] !== updatedTransaction[key] &&
                                String(tx[key]) !== String(updatedTransaction[key]));
                            if (hasChanges) {
                                updatedTransactions.push(Object.assign(Object.assign({}, tx), updatedTransaction));
                            }
                        }
                    }
                }
                if (updatedTransactions.length > 0 && !closed) {
                    txs = (0, storage_1.storeTransactions)(address, chainId, updatedTransactions);
                    setTransactions(txs);
                }
                const pendingTransactions = txs.filter((tx) => (0, utils_1.isPending)(tx.status));
                if (pendingTransactions.length > 0 && !closed) {
                    timer = setTimeout(updateTransactions, Time_1.default.Second * 2);
                }
            });
        }
        updateTransactions();
        return () => {
            closed = true;
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [transactions]);
    const add = (0, react_1.useCallback)((hash, payload = {}) => {
        if (address && chainId) {
            (0, txUtils_1.getTransaction)(address, chainId, hash)
                .then((tx) => {
                if (!tx) {
                    return;
                }
                const newTransaction = Object.assign(Object.assign({}, tx), { timestamp: Date.now(), chainId,
                    payload });
                const txs = (0, storage_1.storeTransactions)(address, chainId, [newTransaction]);
                setTransactions(txs);
            })
                .catch((err) => {
                console.error(err);
                (0, rollbar_1.default)((rollbar) => rollbar.error(err));
                (0, segment_1.default)((analytics) => analytics.track('error', Object.assign(Object.assign({}, err), { message: err.message, stack: err.stack })));
            });
        }
    }, [transactions]);
    const clear = (0, react_1.useCallback)(() => {
        if (!address || !chainId) {
            return;
        }
        setTransactions(initialState);
        (0, storage_1.clearTransactions)(address, chainId);
    }, [transactions]);
    const actions = (0, react_1.useMemo)(() => ({ add, clear }), [add, clear]);
    return [transactions, actions];
}
exports.default = useTransaction;
